var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
class HostServiceInstance {
  getFromHostEnvironment(location, environment) {
    const { protocol, hostname, port, search } = location;
    const queryString = new URLSearchParams(search);
    function azexpEndpoints(proxyServiceUrl, tokenScope) {
      function endpointWithSubdomain(subdomain) {
        const url = new URL(proxyServiceUrl);
        url.hostname = subdomain + "." + url.hostname;
        return { url: url.toString(), tokenScope };
      }
      const defaultEndpoint = { url: proxyServiceUrl, tokenScope };
      const legacyEndpoint = endpointWithSubdomain("legacy");
      return {
        default: defaultEndpoint,
        legacy: legacyEndpoint,
        legacyAPIM: legacyEndpoint,
        expmanAdapter: endpointWithSubdomain("adapter"),
        expanalysis: endpointWithSubdomain("analysis"),
        expmanVCurrent: legacyEndpoint,
        // TODO: Add /api/v2/{**remainer} route to FE proxy
        gatesService: legacyEndpoint,
        // TODO: Add gates.exp.microsoft.com subdomain route to FE proxy
        mds: endpointWithSubdomain("mds"),
        metricService: endpointWithSubdomain("metricshub"),
        cms: defaultEndpoint,
        // TODO: Add /cms/v1/{**remainder} route to FE proxy
        dsms: defaultEndpoint,
        notificationHub: legacyEndpoint,
        // TODO: Add /notificationhub/v1/{**remainder} route to FE proxy
        ticketing: legacyEndpoint,
        // TODO: Add /ticketing/v1/{**remainder} route to FE proxy
        wps: defaultEndpoint,
        // TODO: Implement credential proxying in FE proxy, deprecate WPSProxyConverter and this endpoint.
        vivace: legacyEndpoint,
        // TODO: use metricshub??
        ams: legacyEndpoint
        // TODO: Add /authenticationmanagementservice/v1/{**remainder} route to FE proxy
      };
    }
    let ExpEnvironmentKind;
    ((ExpEnvironmentKind2) => {
      ExpEnvironmentKind2[ExpEnvironmentKind2["PROD"] = 0] = "PROD";
      ExpEnvironmentKind2[ExpEnvironmentKind2["INT"] = 1] = "INT";
      ExpEnvironmentKind2[ExpEnvironmentKind2["USW2"] = 2] = "USW2";
      ExpEnvironmentKind2[ExpEnvironmentKind2["PPE"] = 3] = "PPE";
      ExpEnvironmentKind2[ExpEnvironmentKind2["DEV1"] = 4] = "DEV1";
      ExpEnvironmentKind2[ExpEnvironmentKind2["LOCAL"] = 5] = "LOCAL";
    })(ExpEnvironmentKind || (ExpEnvironmentKind = {}));
    function getEnvironment() {
      var _a;
      function usePreProd() {
        const ppeQs = queryString.get("_ppe") || "";
        const isPpeUiHost = hostname.match(/^ppe/);
        return ppeQs ? ppeQs === "true" : !!isPpeUiHost;
      }
      function isHostname(domain) {
        return hostname === domain || hostname.endsWith("." + domain);
      }
      let envQs = (_a = queryString.get("_env")) == null ? void 0 : _a.toUpperCase();
      if (envQs && envQs in ExpEnvironmentKind) {
        return ExpEnvironmentKind[envQs];
      } else if (usePreProd()) {
        return 1;
      } else if (isHostname("exp.azure.net")) {
        return 2;
      } else if (isHostname("exp-ppe.azure.net")) {
        return 3;
      } else if (isHostname("exp.azure-test.net")) {
        return 4;
      } else if (hostname === "localhost" && port === "8000") {
        return 0;
      } else {
        return 0;
      }
    }
    function legacyProdEndpoint(url) {
      return { url, tokenScope: environment.API_TOKEN_SCOPE };
    }
    function legacyPpeEndpoint(url) {
      return { url, tokenScope: environment.API_TOKEN_SCOPE_PPE };
    }
    switch (getEnvironment()) {
      default:
      case 0:
        var apiBaseUrl = environment.API_BASE_URL;
        if (environment.AZ_EXP_GATEWAY_URL) {
          const gatewayUrl = new URL(environment.AZ_EXP_GATEWAY_URL);
          const hostParts = gatewayUrl.hostname.split(".");
          gatewayUrl.hostname = hostParts.slice(hostParts.length - 3).join(".");
          apiBaseUrl = gatewayUrl.toString();
        }
        return __spreadProps(__spreadValues({}, azexpEndpoints(apiBaseUrl, environment.API_TOKEN_SCOPE)), {
          // endpoints not yet supported by FE proxy routes
          legacy: legacyProdEndpoint("https://exp.microsoft.com"),
          legacyAPIM: legacyProdEndpoint(environment.APIM_BASE_URL_PROD),
          expmanVCurrent: legacyProdEndpoint(environment.APIM_BASE_URL_PROD + "/api/v2"),
          gatesService: legacyProdEndpoint("https://gates.exp.microsoft.com"),
          notificationHub: legacyProdEndpoint(environment.APIM_BASE_URL_PROD + "/notificationhub/v1"),
          // TODO: Add /notificationhub/ routes to FE proxy,
          ticketing: legacyProdEndpoint(environment.TICKETING_BASE_URL_PROD),
          wps: legacyProdEndpoint(environment.WPS_BASE_URL_PROD),
          vivace: legacyProdEndpoint(environment.VIVACE_BASE_URL_PROD),
          ams: legacyProdEndpoint(environment.APIM_BASE_URL_PROD + "/authenticationmanagementservice/v1")
        });
      case 1:
        return __spreadProps(__spreadValues({}, azexpEndpoints("https://exp-ppe.azure.net", environment.API_TOKEN_SCOPE_PPE)), {
          // endpoints not yet supported by FE proxy routes
          legacy: legacyPpeEndpoint("https://ppe.exp.microsoft.com"),
          legacyAPIM: legacyPpeEndpoint("https://ppe.exp.microsoft.com"),
          expmanVCurrent: legacyPpeEndpoint("https://ppe.exp.microsoft.com/api"),
          gatesService: legacyPpeEndpoint("https://gates-int.exp.microsoft.com"),
          dsms: legacyPpeEndpoint(environment.APIM_BASE_URL_PROD + "/datasourcemanagementservice"),
          notificationHub: legacyPpeEndpoint(environment.APIM_BASE_URL_PROD + "/notificationhub-ppe/v1"),
          ticketing: legacyPpeEndpoint(environment.TICKETING_BASE_URL_PPE),
          wps: legacyPpeEndpoint(environment.WPS_BASE_URL_PPE),
          vivace: legacyPpeEndpoint(environment.VIVACE_BASE_URL_PPE),
          ams: legacyPpeEndpoint(environment.AMS_BASE_URL_PPE)
        });
      case 2:
        return __spreadProps(__spreadValues({}, azexpEndpoints("https://exp.azure.net", "https://exp.azure.net/.default")), {
          // endpoints not yet supported by FE proxy routes
          wps: legacyPpeEndpoint(environment.WPS_BASE_URL_PROD),
          vivace: legacyPpeEndpoint(environment.VIVACE_BASE_URL_PROD),
          ams: legacyPpeEndpoint(environment.AMS_BASE_URL_PROD)
        });
      case 3:
        return __spreadProps(__spreadValues({}, azexpEndpoints("https://exp-ppe.azure.net", "https://exp-ppe.azure.net/.default")), {
          // endpoints not yet supported by FE proxy routes
          notificationHub: legacyPpeEndpoint(environment.APIM_BASE_URL_PROD + "/notificationhub-ppe/v1"),
          wps: legacyPpeEndpoint(environment.WPS_BASE_URL_PPE),
          vivace: legacyPpeEndpoint(environment.VIVACE_BASE_URL_PPE),
          ams: legacyPpeEndpoint(environment.AMS_BASE_URL_PPE)
        });
      case 4:
        return __spreadProps(__spreadValues({}, azexpEndpoints("https://exp.azure-test.net", "https://exp.azure-test.net/.default")), {
          // endpoints not yet supported by FE proxy routes
          notificationHub: legacyPpeEndpoint(environment.APIM_BASE_URL_PROD + "/notificationhub-dev/v1"),
          wps: legacyPpeEndpoint(environment.WPS_BASE_URL_PPE),
          vivace: legacyPpeEndpoint(environment.VIVACE_BASE_URL_PPE),
          ams: legacyPpeEndpoint(environment.AMS_BASE_URL_PPE)
        });
      case 5:
        const localProxyEndpoint = {
          url: protocol === "https:" ? "https://localhost:55400" : "http://localhost:55401",
          tokenScope: environment.API_TOKEN_SCOPE
        };
        return {
          default: localProxyEndpoint,
          legacy: localProxyEndpoint,
          legacyAPIM: localProxyEndpoint,
          expmanAdapter: localProxyEndpoint,
          expanalysis: localProxyEndpoint,
          expmanVCurrent: localProxyEndpoint,
          gatesService: localProxyEndpoint,
          mds: localProxyEndpoint,
          metricService: localProxyEndpoint,
          cms: localProxyEndpoint,
          dsms: localProxyEndpoint,
          notificationHub: localProxyEndpoint,
          ticketing: localProxyEndpoint,
          wps: legacyPpeEndpoint(environment.WPS_BASE_URL_DEV),
          vivace: localProxyEndpoint,
          ams: localProxyEndpoint
        };
    }
  }
  get hostSettings() {
    return window["_exp"] || {};
  }
  get endpoints() {
    return this.getFromHostEnvironment(window.location, this.hostSettings.environment);
  }
  get clientId() {
    return this.hostSettings.environment.CLIENT_ID;
  }
  get expUxCdnHost() {
    return this.hostSettings.CDN_HOST || "https://assets.exp.microsoft.com";
  }
  get expUxVersion() {
    return this.hostSettings.version;
  }
  get expUxVersionOverride() {
    return this.hostSettings.versionOverride;
  }
  get expUxCndAssetFolder() {
    return this.hostSettings.CDN_ASSET_FOLDER;
  }
  get expUxCndAssetUrl() {
    return `${this.expUxCdnHost}/${this.expUxCndAssetFolder}/`;
  }
  get getDeviceID() {
    return this.hostSettings.deviceid;
  }
  get isAne() {
    return this.hostSettings.IsAne === "true";
  }
}
const HostService = new HostServiceInstance();
export {
  HostService
};
//# sourceMappingURL=HostService.js.map
